import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { compose } from "recompose";
import DataGrid from "../../../dataGrid/index";
import UNRTDShipmentsGridConfig from "./UNRTDShipmentsGridConfig";
import { withUserProfile } from "../../../../userProfile/userProfileContext";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { observer, inject } from "mobx-react";
import Events from "../../../../utilities/EventEmitter";
import { withSnackbar } from 'notistack';
import styles from '../Common/ModalStyle';
import StatusBar from "../../../dataGrid/StatusBar";
import MESSAGES from "../../../../appMessages";
import appConstant from "../../../../appConstants";

@inject("IBPlanningStore")
@observer
class UNRTDShipmentsModal extends React.Component{
    constructor(props){
        super(props);
        this.gridConfig = new UNRTDShipmentsGridConfig();
        this.state={
            data:null,
        }
    }

    componentDidMount(){
        getDataWithQueryString("GetUNRTDReasons", `scenarioId=${this.props.userData.userProfile.scenarioID}`).then(
            response => {
                if (response.status === 200) {
                    this.setState({data: response.data});
                } else {
                    this.handleError();
                }
            },
            error => {
                this.handleError();
            }
        )
    }

    handleError = () => {
        this.props.enqueueSnackbar(MESSAGES.COMMON.LOADING_DATA, {variant: "error"});
        this.setState({data: []});
    }

    onCellClicked = (params) => {
        if(params.colDef.field === 'proId'){
            this.props.IBPlanningStore.updateSelectedShipments([params.value]);
            Events.emit("RedirectToPage", null, appConstant.NAV_URLS.IBPLANNING_SHIPMENTS);
        }
    }

    constructStatusBar = (filteredData) =>{
        const statusBarData=[
            {
                label:filteredData ? filteredData.length + " UNRTD Shipments":""
            }
        ]
        return statusBarData;
    }

    render(){
        const {container, title, content, UNRTDShipmentGridContainer, closeIcon} = this.props.classes;
        return(
            <div>
                <Dialog
                open={this.props.show}
                onClose={this.props.onClose}
                aria-labelledby="responsive-dialog-title"
                classes = {{paper: container}}
                maxWidth= 'md'
                disablePortal
            >
                <DialogTitle id="responsive-dialog-title" classes={{root: title}} disableTypography >
                    UNRTD Shipments
                    <IconButton onClick={this.props.onClose}>
                        <CloseIcon className= {closeIcon} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={content}>
                    <div className= {UNRTDShipmentGridContainer}>
                        <DataGrid
                            columnDefs={this.gridConfig.config.columns}
                            config={this.gridConfig.config}
                            rowData={this.state.data}
                            onCellClicked={this.onCellClicked}
                            suppressHorizontalScroll={true}
                            panelLabel={ (filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} /> }
                        />
                    </div>
                </DialogContent>
            </Dialog>
            </div>
        )
    }
}

export default compose(withUserProfile, withSnackbar, withStyles(styles))(UNRTDShipmentsModal);